import { all } from "redux-saga/effects";

import { sessionSaga } from "./session";
import { failureSaga } from "./failure";
import { objectsSaga } from "./objects";
import { workListsSaga } from "./worklists";
import { searchSaga } from "./search";
import { tenantsSaga } from "./tenants";
import { auditSaga } from "./audit";
import { authzSaga } from "./authz";
import { pipelineSaga } from "./pipeline";
import { analysisRequestSaga } from "./analysisRequest";
import { eventsSaga } from "./events";
import { hlaEngineVariableSaga } from "./hlaEngineVariable";
import { hlaResultSaga } from "./hla-result";
import { execRuleEnginePipelineSaga } from "./execRuleEnginePipeline";
import { notificationSaga } from "./notification";

export default function* rootSaga(): Generator {
  yield all([
    // Aucun préchargement global au démarrage : la liste complète des patients
    // était chargée ici pour alimenter le sélecteur « Sélectionner un dossier »
    // de la page d'accueil, retiré depuis. Les écrans qui en ont besoin la
    // demandent eux-mêmes, et la palette de recherche interroge le serveur au
    // fil de la frappe.
    objectsSaga(),
    workListsSaga(),
    sessionSaga(),
    searchSaga(),
    tenantsSaga(),
    auditSaga(),
    authzSaga(),
    pipelineSaga(),
    analysisRequestSaga(),
    eventsSaga(),
    failureSaga(),
    hlaEngineVariableSaga(),
    hlaResultSaga(),
    execRuleEnginePipelineSaga(),
    notificationSaga(),
  ]);
}
